import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { getStudentObservationFormAction } from '../actions';

const {
  useLoaderData: StudentObservationFormLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getStudentObservationFormAction,
});

function StudentObservationFormLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { StudentObservationFormLoader, StudentObservationFormLoaderData };
